export var ACTION;
(function (ACTION) {
    ACTION["TEST_ACTION"] = "TEST_ACTION";
    ACTION["CHANGE_INPUT"] = "CHANGE_INPUT";
    ACTION["CHANGE_TAB"] = "CHANGE_TAB";
    ACTION["ON_SEARCH_LEADS"] = "ON_SEARCH_LEADS";
    ACTION["ON_SELECT"] = "ON_SELECT";
    ACTION["ON_SORT"] = "ON_SORT";
    ACTION["ON_SELECT_ALL_LEADS"] = "ON_SELECT_ALL_LEADS";
    ACTION["ON_LOAD"] = "ON_LOAD";
    ACTION["CHANGE_INPUT_AC"] = "CHANGE_INPUT_AC";
    ACTION["ON_SEARCH_AC"] = "ON_SEARCH_AC";
    ACTION["ON_SELECT_AC"] = "ON_SELECT_AC";
    ACTION["ON_SORT_AC"] = "ON_SORT_AC";
    ACTION["ON_SELECT_ALL_AC"] = "ON_SELECT_ALL_AC";
    ACTION["ON_FILTER_LEADS_BY_STATUS"] = "ON_FILTER_LEADS_BY_STATUS";
    ACTION["VALIDATE_FORM_1"] = "VALIDATE_FORM_1";
    ACTION["VALIDATE_FORM_2"] = "VALIDATE_FORM_2";
    ACTION["FILTER_BY_DATE"] = "FILTER_BY_DATE";
    ACTION["ON_SEARCH_RP"] = "ON_SEARCH_RP";
    ACTION["ON_SORT_RP"] = "ON_SORT_RP";
    ACTION["ON_TRACK_CUSTOMER_JOURNEY"] = "ON_TRACK_CUSTOMER_JOURNEY";
    ACTION["REGISTER_CLIENT"] = "REGISTER_CLIENT";
    ACTION["INVITE_CLIENT"] = "INVITE_CLIENT";
    ACTION["LOGOUT"] = "LOGOUT";
    ACTION["GO_TO_HOME"] = "GO_TO_HOME";
    ACTION["GO_TO_FAQ"] = "GO_TO_FAQ";
    ACTION["GO_TO_WHATSAPP"] = "GO_TO_WHATSAPP";
    ACTION["GO_TO_CALL"] = "GO_TO_CALL";
    ACTION["PROMO_INVITE"] = "PROMO_INVITE";
    ACTION["KNOW_MORE"] = "KNOW_MORE";
    ACTION["OPEN_MENU"] = "OPEN_MENU";
    ACTION["VIEW_DETAILS"] = "VIEW_DETAILS";
    ACTION["SHARE_LINK"] = "SHARE_LINK";
    ACTION["MARKETING"] = "MARKETING";
    ACTION["GO_TO_ACCOUNT_DETAIL"] = "GO_TO_ACCOUNT_DETAIL";
})(ACTION || (ACTION = {}));
